import intl from 'react-intl-universal';
import {PAGES} from '@stores/ViewStore';

export const getPageTitle = (page: string): string => {
    switch (page) {
        case PAGES.KNOWLEDGE_BASE:
        case PAGES.DOC_EDIT:
        case PAGES.DOC_HISTORY:
            return intl.get('headerMenu.knowledge').d('Knowledge Base');
        case PAGES.SETTINGS_GENERAL:
            return intl.get('menu_settings.general_settings').d('Company General Settings');
        case PAGES.SETTINGS_MEMBERS:
            return intl.get('menu_settings.general_members').d('Company Members');
        case PAGES.SETTINGS_LOCATIONS:
            return intl.get('menu_settings.locations').d('Locations');
        case PAGES.SETTINGS_BILLING:
            return intl.get('menu_settings.plansAndBillings').d('Plans & Billing');
        case PAGES.WORKSPACE_SETTINGS_GENERAL:
            return intl.get('workspace.menu_settings.settings').d('Workspace General Settings');
        case PAGES.WORKSPACE_MEMBERS:
            return intl.get('workspace.menu_settings.members').d('Workspace Members');
        case PAGES.QUIZZES:
        case PAGES.QUIZ_VIEW:
        case PAGES.QUIZ_EDIT:
        case PAGES.QUIZ_TAKE:
            return intl.get('menu_settings.tests').d('Tests');
        case PAGES.ACKNOWLEDGMENTS_OVERVIEW:
            return intl.get('menu_settings.acknowledgments.overview').d('Acknowledgments Overview');
        case PAGES.LISTS:
            return intl.get('settings-menu.recurring-tasks').d('Recurring Tasks');
        case PAGES.TASK_PERFORMANCE:
            return intl.get('menu_settings.task-performance').d('Task Performance');
        case PAGES.AUDITS:
        case PAGES.AUDIT_VIEW:
        case PAGES.AUDIT_EDIT:
        case PAGES.AUDIT_TAKE:
        case PAGES.AUDIT_LOCATION_RESULT:
            return intl.get('menu_settings.audits').d('Audits');
        case PAGES.ISSUES:
            return intl.get('menu_settings.issues').d('Issues');
        case PAGES.CHARTFLOW:
            return intl.get('menu_settings.chartflow').d('Chartflow');
        case PAGES.SETTINGS_PROFILE:
            return intl.get('profile.header').d('Profile');
        case PAGES.SETTINGS_ACCESSES:
            return intl.get('accesses.header').d('Roles');
        case PAGES.FINANCE:
            return 'Finance';
        default:
            return '';
    }
};
